export default {"src":"/_next/static/media/horoscope.81890efe.svg","height":263,"width":350,"blurWidth":0,"blurHeight":0};